import {
  ChangeDetectionStrategy,
  ChangeDetectorRef,
  Component,
  inject,
  signal,
} from '@angular/core';
import { toSignal } from '@angular/core/rxjs-interop';
import { MatIconButton } from '@angular/material/button';
import { HttpClient } from '@angular/common/http';
import { MatMenu, MatMenuItem, MatMenuTrigger } from '@angular/material/menu';
import { lastValueFrom, map } from 'rxjs';
import { take } from 'rxjs/operators';
import { IconComponent } from '@gains-com/ui-angular';
import { environment } from '../../../../environments/environment';
import { UserFriendsViewService } from '../../../core/view-states/user-friends-view.service';
import { UserAvatarComponent } from '../../../components/avatar/user-avatar.component';
import { LOGGER_FACTORY } from '../../../core/logger/logger-factory.provider';

@Component({
  selector: 'app-friends-list',
  templateUrl: './friends-list.component.html',
  styleUrl: './friends-list.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [
    MatIconButton,
    IconComponent,
    UserAvatarComponent,
    MatMenuTrigger,
    MatMenuItem,
    MatMenu,
  ],
})
export class FriendsListComponent {
  private readonly _userFriendsView = inject(UserFriendsViewService);
  private readonly _cdr = inject(ChangeDetectorRef);
  private readonly _http = inject(HttpClient);
  private readonly _logger = inject(LOGGER_FACTORY).create('FriendsList');

  friends = toSignal(
    this._userFriendsView.state$.pipe(
      map((uf) =>
        uf.map((f) => ({
          user_id: f.friend_id,
          username: f.friend_username,
          avatar_url: f.friend_avatar_url,
        }))
      )
    )
  );

  friendMenuOpenByUserId = signal<Record<string, boolean>>({});

  async removeFriend(friend: {
    user_id: string;
    username: string;
    avatar_url: string | null;
  }) {
    if (!confirm('UI TODO: Are you sure?')) {
      return;
    }

    try {
      await lastValueFrom(
        this._http
          .post(`${environment.apiUrl}/self/remove-friend`, {
            friendId: friend.user_id,
          })
          .pipe(take(1))
      );
    } catch (err) {
      this._logger.error(`Failed to remove friend: ${err}`);
    } finally {
      this._cdr.markForCheck();
    }

    this._userFriendsView.removeFriend(friend.user_id);
  }
}
